import React from 'react';
function MoveMiddle({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M5 12L19 12" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 19L12 15L8 19" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 5L12 9L8 5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default MoveMiddle;
